import type LearningCourseResponse from "~~/package/apis/learning/response/LearningCourseResponse";
import {LearningCourseModel} from "~~/package/mapper/learning/model/LearningCourseModel";
import type TaskResponse from "~~/package/apis/learning/response/TaskResponse";
import {TaskModel} from "~~/package/mapper/learning/model/TaskModel";

export class LearningHelper {
    public static mappingLearningCourse(course: LearningCourseResponse): LearningCourseModel {
        return LearningCourseModel.create(course);
    }

    public static mappingTask(task: TaskResponse): TaskModel {
        return TaskModel.create(task);
    }
}
